module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-sidenav', {
    ref: "revisionNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Revisions")])], 1), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.version.version))]), _vm._v(" "), _c('revisions-list', {
    attrs: {
      "mutations": _vm.mutations
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d172a93","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/history/revisions-nav.vue
// module id = 650
// module chunks = 2